<template>
  <div class="chartWrapper">
    <div class="az_overview_tb_bx">
      <table class="az_overview_tb">
        <thead>
        <tr>
          <td>{{ $t('columnName') }}</td>
          <td>{{ $t('repoerts.sumTasks') }}</td>
        </tr>
        </thead>


        <tbody>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#64D0DA;"></div>
              {{ $t('NEW') }}
            </div>
          </td>
          <td>{{ projectData.NEW || 0 }}</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#877BEB;"></div>
              {{ $t('DOING') }}
            </div>
          </td>
          <td>{{ projectData.DOING || 0 }}</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#FE7297;"></div>
              {{ $t('DONE') }}
            </div>
          </td>
          <td>{{ projectData.DONE || 0 }}</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#67ffc1;"></div>
              {{ $t('TESTING') }}
            </div>
          </td>
          <td>{{ projectData.TESTING || 0 }}</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#EA4A66;"></div>
              {{ $t('VERIFY') }}
            </div>
          </td>
          <td>{{ projectData.VERIFY || 0 }}</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <div class="az_ovw_color mr-3" style="background:#FFC65B;"></div>
              {{ $t('ARCHIVE') }}
            </div>
          </td>
          <td>{{ projectData.ARCHIVE || 0 }}</td>
        </tr>


        <tr class="az_ovw_total">
          <td>{{ $t('repoerts.sumTasks') }}</td>
          <td>{{ projectDataTotal || 0 }}</td>
        </tr>
        </tbody>
      </table>
    </div>


    <div class="az_overview_chart_kan" v-if="series.length > 0">
      <vue-apex-charts type="pie" width="100%" :options="chartOptions" :series="series" :key="$i18n.locale"/>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "TypeKanbanOverall",
  components: {
    VueApexCharts,
  },

  data: () => ({
    projectData: {},
    projectDataTotal: 0,

    series: [],
    chartOptions: {
      colors: ['#64D0DA', '#877BEB', '#FE7297', '#67FFC1FF', '#EA4A66', '#FFC65B'],
      labels: [],
      legend: {
        show: false,
      },
    }
  }),
  created() {
    this.GetProjectAll();
    this.setChartLabels();
  },
  methods: {
    GetProjectAll() {
      this.$api
          .get('reports/by/projects/kanban', {
            params: {
              'forAllProject': true
            }
          })
          .then(response => {
            if (response.data.data[0].reportDtos) {
              this.projectData = response.data.data[0].reportDtos;

              Object.values(this.projectData).forEach(item => {
                this.projectDataTotal += parseInt(item);
              });

              this.series = [
                parseInt(this.projectData.NEW) || 0,
                parseInt(this.projectData.DOING) || 0,
                parseInt(this.projectData.DONE) || 0,
                parseInt(this.projectData.TESTING) || 0,
                parseInt(this.projectData.VERIFY) || 0,
                parseInt(this.projectData.ARCHIVE) || 0,
              ];
            }
          });
    },
    setChartLabels() {
      this.chartOptions.labels = [
        this.$t('NEW'),
        this.$t('DOING'),
        this.$t('DONE'),
        this.$t('TESTING'),
        this.$t('VERIFY'),
        this.$t('ARCHIVE')
      ];
    },
  },
  watch: {
    "$i18n.locale"(lang) {
      this.setChartLabels()
    }
  },
}
</script>
